import Button from './Button'
import Modal from './Modal'
import './ConfirmationDialog.css'

export default function ConfirmationDialog({ open, title, message, confirmLabel, destructive = false, tone = 'default', onConfirm, onClose, cancelLabel = 'Abbrechen', busy = false, busyLabel = 'Bitte warten…' }) {
  const confirmTone = tone !== 'default' ? tone : (destructive ? 'destructive' : 'default')
  return (
    <Modal open={open} title={title} onClose={onClose} className="confirmation-dialog">
      <div className="dialog-message">{message}</div>
      <div className="dialog-actions">
        <Button variant="primary" tone={confirmTone} onClick={onConfirm} disabled={busy} aria-busy={busy || undefined}>
          {busy ? busyLabel : confirmLabel}
        </Button>
        <Button variant="secondary" onClick={onClose}>
          {cancelLabel}
        </Button>
      </div>
    </Modal>
  )
}
